import CountUp from "react-countup";
import Image from "next/image";
import withWindowDimensions from "../shared/withWindowDimensions";

const Stat = ({
  img,
  text,
  end,
  statSuffix,
  statPrefix = "",
  showBorder,
  isVisible,
  isMobileSized,
}) => {
  return (
    <div
      className={`${
        showBorder ? "border-r-2 border-black-200" : ""
      } flex flex-col items-center justify-center h-full px-2`}
    >
      <Image
        className="w-20 lg:w-auto h-auto"
        src={img}
        alt={text}
        width={isMobileSized ? 80 : 149}
        height={isMobileSized ? 80 : 149}
      />
      <p className="text-center text-gray2-600 text-sm md:text-md lg:text-lg mt-1">
        {text}
      </p>
      {isVisible && (
        <CountUp
          start={0}
          end={end}
          duration={2}
          suffix={statSuffix}
          prefix={statPrefix}
          className="text-[20px] xl:text-[60px] text-[#29bcb7] font-bold"
        />
      )}
    </div>
  );
};

export default withWindowDimensions(Stat);
